import React, { MouseEvent, useEffect, useRef, useState } from 'react';

import website from '@src/constants/website';

import './index.scss';

interface CopyRightProps {
  className?: string;
}

const CopyRight: React.FC<CopyRightProps> = (props) => {
  const [year] = useState<number>(new Date().getFullYear());

  const onCookieSettingsClick = (): void => {
    const btn = document.getElementById('ot-sdk-btn');
    if (!btn) return;
    btn.click();
  };

  return (
    <div className="odc-copyright">
      <p className="copyright-item">© 2025-{year} by Serafino Pte. Ltd. All Rights Reserved.</p>
      <div className="copyright-option">
        <div className="copyright-item clickable">
          <a target="_blank"
            rel="noreferrer"
            href={website.privacyPolicy}
          >
            Privacy Policy
          </a>
        </div>
        <div className="copyright-item clickable">
          <a
            target="_blank"
            rel="noreferrer"
            href={website.yourPrivacyChoices}
          >
            Your Privacy Choices
          </a>
        </div>
        <div className="copyright-item clickable">
          <a
            target="_blank"
            rel="noreferrer"
            href={website.cookiePolicy}
          >
            Cookie Policy
          </a>
        </div>
        <div className="copyright-item clickable" onClick={onCookieSettingsClick}>
          cookie settings
        </div>
      </div>
    </div>
  );
};

export default CopyRight;